(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4480);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5678);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92737);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51042);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40238);
/* harmony import */ var _data_useGasSuggestion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54378);
/* harmony import */ var _hooks_useCheckAppVersion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16740);
/* harmony import */ var _hooks_useIsMounted__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76212);
/* harmony import */ var _store_app__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31024);
/* harmony import */ var _store_contract__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29814);
/* harmony import */ var _utils_toChecksumAddress__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2322);
/* harmony import */ var _collection_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(87976);
/* harmony import */ var _collection_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_collection_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);




















var CollectionPage = function CollectionPage(_ref) {
  var _useRecoilValue;

  var chain = _ref.chain,
      description = _ref.description,
      imageUrl = _ref.imageUrl,
      searchedAddress = _ref.searchedAddress,
      title = _ref.title,
      xHandle = _ref.xHandle;
  (0,_hooks_useCheckAppVersion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
  var mainLayoutOrder = ((_useRecoilValue = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(_store_app__WEBPACK_IMPORTED_MODULE_11__/* .displayState */ .YR)) === null || _useRecoilValue === void 0 ? void 0 : _useRecoilValue.main) || _constants__WEBPACK_IMPORTED_MODULE_7__/* .DEFAULT_MAIN_LAYOUT_ORDER */ .Jd;
  var setContractAddress = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useSetRecoilState */ .Zl)(_store_contract__WEBPACK_IMPORTED_MODULE_12__/* .contractAddressState */ .q0);
  var contractAddress = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(_store_contract__WEBPACK_IMPORTED_MODULE_12__/* .checksumContractAddressState */ .bt);
  var contractDetailContainer = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  var setAppSettingModal = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useSetRecoilState */ .Zl)(_store_app__WEBPACK_IMPORTED_MODULE_11__/* .appSettingModalState */ .Kl);
  var isMounted = (0,_hooks_useIsMounted__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
  (0,_data_useGasSuggestion__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
  (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_4__/* .useIsomorphicLayoutEffect */ .LI)(function () {
    // for redirect url from x authentication
    var hashUrls = router.asPath.match(/#([a-z0-9_-]+)/gi);

    if (hashUrls && hashUrls[0] === '#connect-twitter') {
      var _router$asPath$match;

      var result = (_router$asPath$match = router.asPath.match(/\?success=([a-z]+)/)) === null || _router$asPath$match === void 0 ? void 0 : _router$asPath$match[1];

      if (result === 'true') {
        setAppSettingModal({
          history: [5],
          isOpened: true
        });
      } else {
        setTimeout(function () {
          return _components__WEBPACK_IMPORTED_MODULE_5__/* .Toaster.toast */ .x7.toast({
            description: _constants__WEBPACK_IMPORTED_MODULE_7__/* .X_CONNECTION_FAILED_STATEMENT */ .PS,
            type: 'error'
          });
        });
      }
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (router.isReady) {
      var regex = new RegExp(/[^a-zA-Z0-9 ]/g);
      var addressInQuery = router.query.address;
      var chainInQuery = router.query.chain;

      if (regex.test(addressInQuery)) {
        addressInQuery = addressInQuery.replace(regex, '');
        router.replace({
          pathname: "/collection/[chain]/[address]",
          query: {
            address: addressInQuery,
            chain: chainInQuery
          }
        }, undefined, {
          shallow: true
        });
      } else {
        setContractAddress((0,_utils_toChecksumAddress__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(addressInQuery));
      }
    }
  }, [router.isReady, router.query]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if ((contractAddress === null || contractAddress === void 0 ? void 0 : contractAddress.length) > 0) {
      // scroll to top if contract address is changed
      if (contractDetailContainer.current) {
        contractDetailContainer.current.scrollTop = 0;
      }
    }
  }, [contractAddress]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
    children: [// set seo for ssr
    searchedAddress ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Head */ .Fb, {
      description: description,
      imageUrl: imageUrl,
      title: title,
      url: "".concat(_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"].APP_HOST */ .Z.APP_HOST, "/collection/").concat(chain, "/").concat(searchedAddress),
      children: xHandle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("meta", {
        name: "twitter:creator",
        content: xHandle
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Head */ .Fb, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Layout */ .Ar, {
      isLoading: !isMounted,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
        className: (_collection_module_scss__WEBPACK_IMPORTED_MODULE_15___default().container),
        children: mainLayoutOrder.map(function (name, index) {
          var _MAIN_LAYOUT$CONTRACT;

          return (_MAIN_LAYOUT$CONTRACT = {}, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_MAIN_LAYOUT$CONTRACT, _constants__WEBPACK_IMPORTED_MODULE_7__/* .MAIN_LAYOUT.CONTRACT_DETAIL */ .JN.CONTRACT_DETAIL, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("main", {
            className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_collection_module_scss__WEBPACK_IMPORTED_MODULE_15___default().contract_detail_container), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, (_collection_module_scss__WEBPACK_IMPORTED_MODULE_15___default().is_center), (mainLayoutOrder === null || mainLayoutOrder === void 0 ? void 0 : mainLayoutOrder[1]) === _constants__WEBPACK_IMPORTED_MODULE_7__/* .MAIN_LAYOUT.CONTRACT_DETAIL */ .JN.CONTRACT_DETAIL)),
            ref: contractDetailContainer,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .ContractDetail */ .Od, {})
          }, "".concat(name, "_").concat(index))), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_MAIN_LAYOUT$CONTRACT, _constants__WEBPACK_IMPORTED_MODULE_7__/* .MAIN_LAYOUT.LIVE_MINTS */ .JN.LIVE_MINTS, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .LiveMints */ .lM, {}, "".concat(name, "_").concat(index))), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_MAIN_LAYOUT$CONTRACT, _constants__WEBPACK_IMPORTED_MODULE_7__/* .MAIN_LAYOUT.MINTS_OVERVIEW */ .JN.MINTS_OVERVIEW, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .MintsOverview */ .qI, {}, "".concat(name, "_").concat(index))), _MAIN_LAYOUT$CONTRACT)[name];
        })
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CollectionPage);

/***/ }),

/***/ 52779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _collection_chain_address___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8599);

/* harmony default export */ __webpack_exports__["default"] = (_collection_chain_address___WEBPACK_IMPORTED_MODULE_0__["default"]);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(52779);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87976:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"collection_container__j1RRj","contract_detail_container":"collection_contract_detail_container__90hQU","is_center":"collection_is_center__cBsKP"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);